// extracted by mini-css-extract-plugin
module.exports = {"contentGrid":"UserPage_contentGrid__1wNCS","roleField":"UserPage_roleField__3sXG9","modal":"UserPage_modal__3H7qi"};